module.exports = __webpack_public_path__ + "static/media/orbitron-bold.cfa3aa04.ttf";